export default __webpack_public_path__ + "static/media/cintura.f65f510e.png";